import React, {useEffect, useRef, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TextInput,
  Modal,
  FlatList,
  Alert,
} from 'react-native';
import {fetchAvailableLanguages} from '../../Redux/Actions/ghaAction';
import {CHEVRON_DOWN} from '../../assets';
import CustomCheckBox from '../../components/checkBox/checkBox';
import GHATermsAndCondition from './ghaTermsAndCondition';
import Recaptcha from 'react-native-recaptcha-that-works/dist/Recaptcha';
import {GOOGLE_CAPTCHA_KEY} from '../../config/Constant';
import WebView from 'react-native-webview';
import ReCaptchaWebView from '../../components/checkBox/recaptchaWebView';
import {
  containsSpecialCharsAndNumber,
  emailRegex,
  isStrongPassword,
} from '../../utils/validation';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { COLOR_BROWN, COLOR_GREY, LIGHT_GREY, MAIN_HEADER_SUB_TITLE, MAIN_HEADER_TITLE } from '../../style';

const GHANewJoin = ({navigation}) => {
  const [languages, setLanguages] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    language: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  // const [captchaToken, setCaptchaToken] = useState('');

  // const handleVerify = token => {
  //   setCaptchaToken(token);
  //   Alert.alert('Captcha Verified!', `Token: ${token}`);
  // };

  const recaptchaRef = useRef();

  const onVerify = token => {
    console.log('reCAPTCHA token:', token);
    Alert('reCAPTCHA token:' + token);
  };

  // const onRecaptchaLoad = () => {
  //   console.log('reCAPTCHA loaded');
  //   Alert('reCAPTCHA loaded');
  // };

  const SITE_KEY_CAPTCHA = GOOGLE_CAPTCHA_KEY;

  const validateName = name => {
    if (!name.trim()) {
      return 'Name is required and cannot be empty or only spaces.';
    }
    if (containsSpecialCharsAndNumber(name)) {
      return 'Name cannot contain special characters or numbers.';
    }
    return null;
  };

  const handleSubmit = () => {
    const {language, firstName, lastName, email, password, confirmPassword} =
      formData;

    let languageError = '';
    let firstNameError = '';
    let lastNameError = '';
    let emailError = '';
    let passwordError = '';
    let confirmPasswordError = '';

    if (language === '') {
      languageError = 'Please select a language';
    }
    firstNameError = validateName(firstName);
    lastNameError = validateName(lastName);
    if (!emailRegex.test(email)) {
      emailError = 'Please enter a valid email address.';
    }
    if (!isStrongPassword(password)) {
      passwordError =
        'Password must be at least 8 characters long, contain uppercase letters, numbers, symbols, and no spaces.';
    }
    if (password !== confirmPassword) {
      confirmPasswordError = 'Passwords do not match.';
    }
    setError({
      language: languageError,
      firstName: firstNameError,
      lastName: lastNameError,
      email: emailError,
      password: passwordError,
      confirmPassword: confirmPasswordError,
    });
    if (
      languageError ||
      firstNameError ||
      lastNameError ||
      emailError ||
      passwordError ||
      confirmPasswordError
    ) {
      return;
    }
    // Trigger the reCAPTCHA after validation is successful
    if (recaptchaRef.current) {
      recaptchaRef.current.open(); // Assuming you have a ref for the reCAPTCHA component
      // onVerify()
      return;
    }
    
    // Handle form submission if no errors
    console.log('Form Data:', formData);
    Alert.alert('Success', 'Form submitted successfully!');
  };

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const data = await fetchAvailableLanguages();
        let lang = data?.data?.payload;
        setLanguages(lang);
      } catch (error) {
        console.error('Error fetching Languages:', error);
      }
    };

    fetchLanguages();
  }, []);

  const availableLanguages = languages?.data;
  const ppLink = languages?.ppLink;
  const tncLink = languages?.tncLink;

  const handleInputChange = (name, value) => {
    setFormData({...formData, [name]: value});
    // Clearing errors related to the changed field
    setError(prevError => ({
      ...prevError,
      [name]: '',
    }));
  };

  const renderLanguageItem = ({item}) => (
    <CustomPressable
      style={styles.languageItem}
      onPress={() => {
        handleInputChange('language', item.name);
        setModalVisible(false);
      }}>
      <Text style={styles.languageText}>{item.name}</Text>
    </CustomPressable>
  );

  return (
    <View style={styles.ghaNewJoinContainer}>
      <HeaderWithBack navigation = {navigation} />
      <ScrollView
        style={styles.contentContainer}
        showsVerticalScrollIndicator={false}>
        <ImageComp source={null} style={styles.image} />

        <Text style={styles.title}>
          <Text style={styles.titleBold}>JOIN</Text> VICEROY DISCOVERY LOYALTY
        </Text>

        <View style={styles.loginInfoContainer}>
          <Text style={styles.loginInfoTitle}>Account information</Text>

          <Text style={styles.label}>
            Language Preference<Text style={styles.star}>*</Text>{' '}
          </Text>

          <CustomPressable
            style={styles.dropdown}
            onPress={() => setModalVisible(true)}>
            <Text style={styles.dropdownText}>
              {formData.language || 'Select a language'}
            </Text>
            <ImageComp source={CHEVRON_DOWN} style={styles.dropDownIcon} />
          </CustomPressable>
          {error.language ? (
            <Text style={styles.errorText}>{error.language}</Text>
          ) : null}

          <Text style={styles.label}>
            First name<Text style={styles.star}>*</Text>
          </Text>

          <TextInput
            style={styles.input}
            placeholder="Enter your first name"
            placeholderTextColor="gray"
            value={formData.firstName}
            onChangeText={text => handleInputChange('firstName', text)}
          />
          {error.firstName ? (
            <Text style={styles.errorText}>{error.firstName}</Text>
          ) : null}

          <Text style={styles.label}>
            Last name<Text style={styles.star}>*</Text>{' '}
          </Text>

          <TextInput
            style={styles.input}
            placeholder="Enter your last name"
            placeholderTextColor="gray"
            value={formData.lastName}
            onChangeText={text => handleInputChange('lastName', text)}
          />
          {error.lastName ? (
            <Text style={styles.errorText}>{error.lastName}</Text>
          ) : null}

          <Text style={styles.label}>
            Email Address<Text style={styles.star}>*</Text>{' '}
          </Text>

          <TextInput
            style={styles.input}
            placeholder="Enter your email address"
            placeholderTextColor="gray"
            value={formData.email}
            onChangeText={text => handleInputChange('email', text)}
          />
          {error.email ? (
            <Text style={styles.errorText}>{error.email}</Text>
          ) : null}

          <Text style={styles.label}>
            Password<Text style={styles.star}>*</Text>
          </Text>

          <TextInput
            style={styles.input}
            placeholder="Enter your password"
            placeholderTextColor="gray"
            secureTextEntry
            value={formData.password}
            onChangeText={text => handleInputChange('password', text)}
          />
          {error.password ? (
            <Text style={styles.errorText}>{error.password}</Text>
          ) : null}

          <Text style={styles.label}>
            Confirm Password<Text style={styles.star}>*</Text>
          </Text>

          <TextInput
            style={styles.input}
            placeholder="Retype your password"
            placeholderTextColor="gray"
            secureTextEntry
            value={formData.confirmPassword}
            onChangeText={text => handleInputChange('confirmPassword', text)}
          />
          {error.confirmPassword ? (
            <Text style={styles.errorText}>{error.confirmPassword}</Text>
          ) : null}

          <Text style={styles.sectionTitle}>Marketing Communications</Text>
          <View style={styles.checkboxContainer}>
            <CustomCheckBox />
            <Text style={styles.checkboxText}>
              I WOULD LIKE TO RECEIVE EMAILS ABOUT GHA DISCOVERY PROMOTIONS AND
              SPECIAL OFFERS. I CAN UNSUBSCRIBE AT ANY TIME FROM FUTURE EMAILS
              AND MANAGE MY EMAIL SUBSCRIPTIONS.
            </Text>
          </View>
          <View style={styles.checkboxContainer}>
            <CustomCheckBox />
            <Text style={styles.checkboxText}>
              I WOULD LIKE TO RECEIVE EMAILS ABOUT VICEROY PROMOTIONS AND
              SPECIAL OFFERS. I CAN UNSUBSCRIBE AT ANY TIME FROM FUTURE EMAILS
              AND MANAGE MY EMAIL SUBSCRIPTIONS.
            </Text>
          </View>
          <Text style={styles.sectionTitle}>Terms & Conditions</Text>
          <GHATermsAndCondition
            termsAndCondition={tncLink}
            GHAPrivacyPolicy={ppLink}
          />
          {/* <View
            style={{
              height: 100,
              width: '100%',
              backgroundColor: '#f0f0f0',
              justifyContent: 'center',
              alignItems: 'center',
            }}> */}
          <Recaptcha
            ref={recaptchaRef}
            siteKey={SITE_KEY_CAPTCHA}
            baseUrl="https://guest-journey.s3.amazonaws.com/static/captcha.html?site_key=$"
            onVerify={onVerify}
            // onLoad={recaptchaRef.current.open()}
          />
          {/* <View
            style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
            <Text>Please complete the CAPTCHA below:</Text>
            <ReCaptchaWebView
              siteKey={SITE_KEY_CAPTCHA}
              onVerify={handleVerify}
            />
            {captchaToken ? (
              <Text style={{marginTop: 20}}>CAPTCHA Token: {captchaToken}</Text>
            ) : null}
          </View> */}
          {/* </View> */}
          {/* <Button
            title="Show Recaptcha"
            onPress={() => recaptchaRef.current.open()}
          /> */}
        </View>
        <View style={styles.bottomSpacer} />
      </ScrollView>
      <CustomPressable style={styles.becomeMemberBtn} onPress={handleSubmit}>
        <Text style={styles.becomeMemberBtnTxt}>BECOME A MEMBER</Text>
      </CustomPressable>

      <Modal
        visible={modalVisible}
        transparent={true}
        onRequestClose={() => setModalVisible(false)}>
        <CustomPressable
          style={styles.modalContainer}
          activeOpacity={1}
          onPressOut={() => setModalVisible(false)}>
          <CustomPressable activeOpacity={1} style={styles.modalContent}>
            <Text style={styles.modalTitle}>Select a language</Text>
            <FlatList
              data={availableLanguages}
              renderItem={renderLanguageItem}
              keyExtractor={item => item.id.toString()}
              showsVerticalScrollIndicator={true}
            />
          </CustomPressable>
        </CustomPressable>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  ghaNewJoinContainer: {
    flex: 1,
    backgroundColor: 'white',
  },
  image: {
    width: '100%',
    height: 230,
  },
  contentContainer: {
    marginHorizontal: 20,
  },
  title: {
    marginTop: 10,
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 30,
    marginHorizontal: 20,
    fontFamily: MAIN_HEADER_TITLE,
  },
  titleBold: {
    fontWeight: 'bold',
    color: COLOR_BROWN,
  },
  loginInfoContainer: {
    backgroundColor: LIGHT_GREY,
    padding: 20,
  },
  loginInfoTitle: {
    fontSize: 20,
    fontWeight: '500',
    marginBottom: 25,
    marginTop: 10,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  label: {
    fontSize: 13,
    fontWeight: '500',
    marginBottom: 8,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  input: {
    borderWidth: 1,
    borderColor: '#000',
    paddingHorizontal: 10,
    fontSize: 16,
    paddingVertical: 11,
    marginBottom: 5,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  becomeMemberBtn: {
    backgroundColor: '#000',
    paddingVertical: 20,
    alignItems: 'center',
    marginBottom: 30,
    marginHorizontal: 20,
  },
  becomeMemberBtnTxt: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  resetButton: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#000',
    paddingVertical: 15,
    alignItems: 'center',
  },
  resetButtonText: {
    color: 'black',
    fontSize: 16,
    fontWeight: 'bold',
  },
  bottomSpacer: {
    height: 60,
  },
  star: {
    color: 'red',
    fontSize: 18,
  },
  dropDownIcon: {
    width: 20,
    height: 20,
  },
  sectionTitle: {
    fontSize: 23,
    fontWeight: '500',
    marginVertical: 10,
    color: COLOR_GREY,
    marginBottom: 20,
  },
  checkboxText: {
    marginLeft: 12,
    fontSize: 14,
    color: COLOR_GREY,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 15,
  },
  errorText: {
    color: 'red',
    fontSize: 11,
    marginBottom: 10,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },

  // Modal & language
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    width: '80%',
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 16,
  },
  languageItem: {
    padding: 8,
  },
  languageText: {
    fontSize: 16,
    color: COLOR_GREY,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  dropdown: {
    borderWidth: 1,
    borderColor: COLOR_GREY,
    justifyContent: 'space-between',
    padding: 8,
    borderRadius: 8,
    marginBottom: 5,
    flexDirection: 'row',
  },
  dropdownText: {
    fontSize: 16,
    color: COLOR_GREY,
  },
  modalTitle: {
    paddingBottom: 15,
    fontSize: 20,
    letterSpacing: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontFamily: MAIN_HEADER_TITLE
  },
});

export default GHANewJoin;
